import type { GrowingMedium, PlantSummary } from "../shared/types";
import { GROWING_MEDIA } from "../shared/types";

/** Sentinel for null / empty metadata in filter chips. */
export const METADATA_UNSET = "__unset__";

export function plantLocationKey(location: string | null | undefined): string {
  const trimmed = location?.trim();
  return trimmed || METADATA_UNSET;
}

export function plantGrowingKey(medium: GrowingMedium | null | undefined): string {
  return medium ?? METADATA_UNSET;
}

export function locationFilterLabel(key: string): string {
  return key === METADATA_UNSET ? "No location" : key;
}

export function growingMediumFilterLabel(key: string): string {
  if (key === METADATA_UNSET) return "Not set";
  if (key === "hydroponic") return "Hydroponic";
  if (key === "soil") return "Potted in soil";
  return key;
}

export function collectLocationFilterKeys(plants: PlantSummary[]): string[] {
  const keys = new Set<string>();
  for (const p of plants) keys.add(plantLocationKey(p.location));
  return [...keys].sort((a, b) => {
    if (a === METADATA_UNSET) return 1;
    if (b === METADATA_UNSET) return -1;
    return a.localeCompare(b, undefined, { sensitivity: "base" });
  });
}

export function collectGrowingFilterKeys(plants: PlantSummary[]): string[] {
  const keys = new Set<string>();
  for (const p of plants) keys.add(plantGrowingKey(p.growing_medium));
  const ordered: string[] = GROWING_MEDIA.filter((m) => keys.has(m));
  if (keys.has(METADATA_UNSET)) ordered.push(METADATA_UNSET);
  return ordered;
}

export function matchesPlantMetadataFilters(
  plant: PlantSummary,
  locationFilter: ReadonlySet<string>,
  growingFilter: ReadonlySet<string>,
): boolean {
  if (locationFilter.size > 0 && !locationFilter.has(plantLocationKey(plant.location))) return false;
  if (growingFilter.size > 0 && !growingFilter.has(plantGrowingKey(plant.growing_medium))) return false;
  return true;
}

export function toggleFilterKey(keys: ReadonlySet<string>, key: string): Set<string> {
  const next = new Set(keys);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  return next;
}
